import { render } from "./exportFile.vue?vue&type=template&id=35583093"
import script from "./exportFile.vue?vue&type=script&lang=js"
export * from "./exportFile.vue?vue&type=script&lang=js"

import exportComponent from "/home/lcs/jenkins/workspace/v2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__